// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2awjJ","notes":"Notes_notes__3H64N","note":"Notes_note__QcXyT","markdown":"Notes_markdown__3k5ok"};